export class Router {
  constructor() {
    this.currentView = 'welcome';
    this.views = new Map();
    this.transitions = {
      duration: 500,
      easing: 'ease-in-out'
    };
  }

  registerView(name, viewInstance) {
    this.views.set(name, viewInstance);
  }

  async navigateTo(viewName, data = {}) {
    if (!this.views.has(viewName)) {
      console.error(`View "${viewName}" not found`);
      return;
    }

    const currentViewInstance = this.views.get(this.currentView);
    const targetViewInstance = this.views.get(viewName);

    // Hide current view with animation
    if (currentViewInstance && currentViewInstance.hide) {
      await currentViewInstance.hide();
    }

    // Update current view
    this.currentView = viewName;

    // Show new view with animation
    if (targetViewInstance && targetViewInstance.show) {
      await targetViewInstance.show(data);
    }

    // Fire navigation event
    this.onNavigate(viewName, data);
  }

  getCurrentView() {
    return this.currentView;
  }

  onNavigate(viewName, data) {
    // Override this method to handle navigation events
  }

  // Utility method for smooth transitions
  static async fadeOut(element, duration = 500) {
    return new Promise((resolve) => {
      element.style.transition = `opacity ${duration}ms ease`;
      element.style.opacity = '0';
      setTimeout(resolve, duration);
    });
  }

  static async fadeIn(element, duration = 500) {
    return new Promise((resolve) => {
      element.style.transition = `opacity ${duration}ms ease`;
      element.style.opacity = '1';
      setTimeout(resolve, duration);
    });
  }

  // Slide transitions
  static async slideOut(element, direction = 'left', duration = 500) {
    return new Promise((resolve) => {
      const transform = direction === 'left' ? 'translateX(-100%)' : 'translateX(100%)';
      element.style.transition = `transform ${duration}ms ease`;
      element.style.transform = transform;
      setTimeout(() => {
        element.style.display = 'none';
        resolve();
      }, duration);
    });
  }

  static async slideIn(element, direction = 'right', duration = 500) {
    return new Promise((resolve) => {
      const initialTransform = direction === 'right' ? 'translateX(100%)' : 'translateX(-100%)';
      element.style.display = 'block';
      element.style.transform = initialTransform;
      element.style.transition = `transform ${duration}ms ease`;
      
      requestAnimationFrame(() => {
        element.style.transform = 'translateX(0)';
        setTimeout(resolve, duration);
      });
    });
  }
}